<template>
    <div class="funItem">
        <div class="itemTitle">{{ title }}</div>
        <div class="DownFlex">
            <div :key="item.id" v-for="item in list" class="DownItem">
                <img class="topImage" :src="item.cover" alt="" />
                <div class="name1">{{ item.title }}</div>
                <div class="name2">{{ item.desc }}</div>
                <div class="fileInfo">
                    <div class="info">
                        <span class="name">{{ $t('i18n_434') }}</span>
                        <span class="val">{{ item.page_size }}</span>
                    </div>
                    <div class="info">
                        <span class="name">{{ $t('i18n_435') }}</span>
                        <span class="val">{{ item.file_size }}MB</span>
                    </div>
                </div>
                <div @click="downloadFile(item.url)" class="downBtn">{{ $t('download.downloadBtn') }}</div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        title: {
            type: String,
            default: '',
        },
        list: {
            type: Array,
            default: (() => []),
        },
    },
    data() {
        return {

        }
    },
    created() {

    },
    methods: {
        downloadFile(url) {
            // 浏览器直接导航无法携带自定义请求头，把语言作为查询参数附加到 URL，
            // 后端 getLang() 会回退读取，确保命中正确语言库
            const lang = (this.$i18n && this.$i18n.locale) || 'zh'
            const sep = url.indexOf('?') === -1 ? '?' : '&'
            url = url + sep + 'lang=' + encodeURIComponent(lang)
            const a = document.createElement('a')
            a.download = url
            a.href = url
            a.target = '_blank'
            document.body.appendChild(a)
            a.click()
            document.body.removeChild(a)
        }
    },
}
</script>

<style lang="scss" scoped>
.funItem {
    margin-top: 0px;
    margin-bottom: 116px;

    .itemTitle {
        font-weight: 500;
        font-size: 40px;
        color: #000000;
        width: 1200px;
        margin: auto;
    }

    .DownFlex {
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        width: 1200px;
        margin: auto;
        margin-top: 46px;
        gap: 48px;

        .DownItem {
            width: 260px;

            .topImage {
                width: 100%;
                height: 350px;
                object-fit: cover;
                display: block;
            }

            .name1 {
                margin-top: 30px;
                font-size: 22px;
                font-weight: bold;
            }

            .name2 {
                font-size: 20px;
                line-height: 28px;
                margin-top: 10px;
            }

            .fileInfo {
                display: flex;
                justify-content: space-between;
                margin-top: 28px;

                .info {
                    font-size: 18px;

                    .name {
                        font-weight: bold;
                    }
                }
            }

            .downBtn {
                margin-top: 20px;
                font-size: 21px;
                color: #0083FF;
                line-height: 30px;
                cursor: pointer;
            }
        }
    }
}

@media screen and (max-width:1200px) {
    .funItem {
        margin-top: 46px;

        .itemTitle {
            font-weight: 500;
            font-size: 18px;
            color: #000000;
            width: 100%;
            margin: auto;
        }

        .DownFlex {
            width: 100%;
            display: flex;
            align-items: center;
            flex-wrap: wrap;
            margin: auto;
            margin-top: 46px;
            gap: 30px;

            .DownItem {
                width: calc((100% - 30px) / 2);

                .topImage {
                    width: 100%;
                    height: auto;
                    object-fit: cover;
                    display: block;
                }

                .name1 {
                    margin-top: 16px;
                    font-size: 16px;
                    font-weight: bold;
                }

                .name2 {
                    font-size: 14px;
                }

                .fileInfo {
                    display: flex;
                    justify-content: space-between;
                    margin-top: 18px;

                    .info {
                        font-size: 12px;

                        .name {
                            font-weight: bold;
                        }

                        .val {}
                    }
                }

                .downBtn {
                    margin-top: 15px;
                    font-size: 16px;
                    color: #0083FF;
                    line-height: 20px;
                    cursor: pointer;
                }
            }
        }
    }
}
</style>